import React from "react";
// import ActionSwapHoriz from "material-ui/svg-icons/action/swap-horiz";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import NavigationCancel from "material-ui/svg-icons/navigation/cancel";
import { Link } from "react-router-dom";
import { getDollarFormat, convertDateToString, splitWords } from "./helpers";
import IconMenu from "../screens/components/basic/IconMenu";
import Button from "../screens/components/basic/Button";
import ToggleInput from "../screens/components/basic/ToggleInput";
import TextInput from "../screens/components/basic/TextInput";
import TextInputOnBlurCallApi from "../screens/components/basic/TextInputOnBlurCallApi";
import DecimalInputInventoryAdjust from "../screens/components/basic/DecimalInputInventoryAdjust";
import DecimalInputInventoryAdjustEstimatedQty from "../screens/components/basic/DecimalInputInventoryAdjustEstimatedQty";
import WeightInput from "../screens/components/basic/WeightInput";
import SelectInput from "../screens/components/basic/SelectInput";
import LotNumberSelect from "../screens/components/basic/LotNumberSelect";
import LOOKUP from "../constants/lookup";
import { MeasurementType, OrderDiscountType } from "../constants/enums";
// import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import DecimalInput from '../screens/components/basic/DecimalInput';
import imgDefault from '../images/imgDefault.jpg';
import eliteImage from '../images/elite-img.png';
import moment from 'moment';
import CancelIcon from '@mui/icons-material/Cancel';
import UseNavigateAssistant from "custom/UseNavigateAssistant";

export const mapPatients = (patients = [], addToCheckIn, isMedical, rewardPointsDivider) => {
  return patients.map((item, index) => {
    return {
      Id: (
        <Link id={`linkViewMember-${index}`} className="edit-link" to={`/member/${item.id}`}>
          {item.id}
        </Link>
      ),
      FullName: (
        <Link to={`/member/${item.id}`}>
          {isMedical ? (
            <span className="list-item-photo-container list-item d-none-xs">
              <img className="list-item-photo" src={item.photo} />
            </span>
          ) : (
            ""
          )}
          <span className="list-item list-item-name">
            {item.firstName + " " + item.lastName}
          </span>
        </Link>
      ),
      Birthdate: item.dateOfBirth
        ? new Date(item.dateOfBirth).toISOString().slice(0, 10)
        : "-",
      RewardPoints: item.rewardPoints,
      PointsValue: getDollarFormat(item.rewardPoints / rewardPointsDivider),
      VisitCount: item.visitCount,
      Status:
        item.status !== "Active" ? (
          <p className="statusIconRed m-0">{item.status}</p>
        ) : (
          <p className="statusIconGreen m-0">{item.status}</p>
        ),
      Checkin: (
        <Button
          className="check-inBtn"
          type="CheckIn"
          label="Check-in"
          mini={true}
          onTouchTap={() => addToCheckIn(item.id)}
        />
      ),
      Icons: (
        <UseNavigateAssistant component={<Button
          type="IconEditButton"
          id={`buttonEditMember-${index}`}
          mini={true}
        />} route={`/member/edit/${item.id}`} />
      )
    };
  });
};

export const mapPatientsNoRewards = (patients = [], addToCheckIn, isMedical) => {
  return patients.map((item) => {
    return {
      Id: (
        <Link className="edit-link" to={`/member/${item.id}`}>
          {item.id}
        </Link>
      ),
      FullName: (
        <Link to={`/member/${item.id}`}>
          {isMedical ? (
            <span className="list-item-photo-container list-item d-none-xs">
              <img className="list-item-photo" src={item.photo} />
            </span>
          ) : (
            ""
          )}
          <div className="text-left">
            <span className="list-item ">
              {item.isElite ? <img src={eliteImage} style={{ width: '13px', marginRight: '0.5rem' }} /> : ""} {item.firstName + " " + item.lastName}
            </span>
          </div>
        </Link>
      ),
      Birthdate: item.dateOfBirth
        ? new Date(item.dateOfBirth).toISOString().slice(0, 10)
        : "-",
      Status:
        item.status !== "Active" ? (
          <p className="statusIconRed m-0">{item.status}</p>
        ) : (
          <p className="statusIconGreen m-0">{item.status}</p>
        ),
      Checkin: (
        <Button
          className="check-inBtn"
          type="CheckIn"
          label="Check-in"
          mini={true}
          onTouchTap={() => addToCheckIn(item.id)}
        />
      ),
      Icons: (
        <UseNavigateAssistant component={<Button
          type="IconEditButton"
          mini={true}
        />} route={`/member/edit/${item.id}`} />
      )
    };
  });
};

export const mapOrders = (orders = []) => {
  return orders.map((order) => {
    return {
      Id: (
        <Link to={`/admin/orders/detail/${order.orderNumber}`}>
          {" "}
          {order.orderNumber}{" "}
        </Link>
      ),
      CreatedDate: order.orderDate,
      PatientFirstName:
        (
          <Link to={`/member/${order.memberId}`}>
            {" "}
            {order.recipient != "" ? <u>{order.recipient}</u> : "Anonymous"}{" "}
          </Link>
        ),
      EmployeeFirstName: order.employee != "" ? `${order.employee}` : "",
      total: `${getDollarFormat(order.total)}`
    };
  });
};

export const mapOrdersPatient = (orders = []) => {
  return orders.map((order) => {
    return {
      Id: (
        <Link to={`/admin/orders/detail/${order.orderNumber}`}>
          {" "}
          {order.orderNumber}{" "}
        </Link>
      ),
      CreatedDate: order.orderDate,
      PatientFirstName:
        (
          <Link to={`/member/${order.memberId}`}>
            {" "}
            {order.recipient != "" ? <u>{order.recipient}</u> : "Anonymous"}{" "}
          </Link>
        ),
      EmployeeFirstName: order.employee != "" ? `${order.employee}` : "",
      total: `${getDollarFormat(order.total)}`,
      MemberPriceSavings: `${getDollarFormat(order.memberSavingTotal != null ? order.memberSavingTotal : "")}`
    };
  });
};

export const mapEmployeeShifts = (shifts = []) => {
  return shifts.map((shift) => {
    return {
      date: (
        <Link to={`/admin/shift/edit/${shift.shiftId}/${shift.punchInDate}`}>
          {" "}
          {shift.shiftDate}{" "}
        </Link>
      ),
      employeeFullName: shift.employeeFullName,
      punchInDate: shift.punchInTime,
      punchOutDate: shift.punchOutTime,
      paidBreak: shift.paidBreak,
      status: shift.status
    };
  });
};

export const mapPo = (pos = []) => {
  return pos.map((item) => {
    return {
      ID: (
        <Link className="edit-link" to={`/purchaseOrder/edit/${item.id}`}>
          {item.id}
        </Link>
      ),
      Description: (
        <Link to={`/purchaseOrder/edit/${item.id}`}>{item.description}</Link>
      ),
      Total: `${getDollarFormat(item.total)}`,
      PaymentDueDate: item.paymentDueDate
        ? convertDateToString(item.paymentDueDate)
        : "-",
      DateExpected: item.dateExpected
        ? convertDateToString(item.dateExpected)
        : "-",
      Qty: item.products ? item.products.length : 0,
      Status: item.status,
      CreatedDate: item.creationDateString
    };
  });
};

export const mapCampaign = (campaigns = []) => {
  return campaigns.map((item) => {
    return {
      Name: (
        <Link className="edit-link" to={`/manage/campaign/edit/${item.id}`}>
          {item.name}
        </Link>
      ),
      Period: item.period,
      Type: item.typeText == "One Time Sale" ? "One Time" : "Recurrent",
      WeekDays: item.daysOfWeekToApplyText,
      Status: item.statusText,
      Discount: item.discountText
    };
  });
};

export const mapSKUMapping = (productSupplier) => {
  return (productSupplier || []).map((item) => {
    return {
      SupplierProductCode: item.supplierProductCode,
      CaseQty: item.caseQty,
      SupplierName: item.supplierName,
      WholeSale: item.wholeSale,
      ProvinceCode: item.provinceCode,
      THC_Range: item.thC_Range,
      CBD_Range: item.cbD_Range,
      THC: item.thc,
      CBD: item.cbd
    }
  })
}

export const mapPoints = (points = []) => {
  return points.map((point) => {
    return {
      Date: point.date,
      Point: point.point,
      Comment: point.comment
    };
  });
};

export const mapDashboardPO = (value = []) => {
  return value.map((item) => {
    return {
      ID: item.id,
      Total: item.total,
      DateExpected: item.dateExpected
    };
  });
};

export const mapDbTopProduct = (value = []) => {
  return value.map((item) => {
    return {
      productName: item.productName,
      totalSold: item.totalSold
    };
  });
};

export const mapDbTopSellers = (value = []) => {
  return value.map((item) => {
    return {
      Name: item.employeeName,
      Sold: (
        <span className="green-text">{getDollarFormat(item.amountSold)}</span>
      )
    };
  });
};

export const mapDbTopMember = (value = []) => {
  return value.map((item) => {
    return {
      Name: (
        <div className="font-14px">
          <span className="list-item-photo-container list-item d-none-xs">
            <img className="list-item-photo" src={item.photo} />
          </span>
          <span className="list-item list-item-name">{item.name}</span>
        </div>
      ),
      Points: item.rewardPoints
    };
  });
};

export const mapDbInventory = (value = []) => {
  return value.map((item) => {
    return {
      Product: item.product,
      Quantity: item.remainingQuantity
    };
  });
};

export const mapDbClockIn = (value = []) => {
  return value.map((item) => {
    return {
      Employee: item.employeeName,
      ClockIn: <div className="green-text">{item.clockInTime}</div>,
      ClockOut: <div className="danger">{item.clockOutTime}</div>
    };
  });
};

export const mapDbCashFlow = (value = []) => {
  return value.map((item) => {
    return {
      station: item.workStation,
      employee: item.employee,
      cashIn: (
        <div className="row m-0">
          <div className="col-lg-6 p-0">
            <span className="green-text">
              {getDollarFormat(item.currentAmount)}
            </span>
          </div>
          <div className="col-lg-6 p-0">
            {/* <AccessAlarmsIcon className="iconDB_table" /> */}
            <span className="grey-text">{item.cashInTime}</span>
          </div>
        </div>
      ),
      cashDrop: (
        <div className="row m-0">
          <div className="col-lg-6 p-0">
            <span className="danger">
              {getDollarFormat(item.lastCashDropAmount)}
            </span>
          </div>
          <div className="col-lg-6 p-0">
            {/* <DeviceAccessTime className="iconDB_table" /> */}
            <span className="grey-text">{item.lastCashDropTime}</span>
          </div>
        </div>
      ),
      cashOut: (
        <div className="row m-0">
          <div className="col-lg-6 p-0">
            <span className="green-text">
              {getDollarFormat(item.cashOutAmount)}
            </span>
          </div>
          <div className="col-lg-6 p-0">
            {/* <DeviceAccessTime className="iconDB_table" /> */}
            <span className="grey-text">{item.cashOutTime}</span>
          </div>
        </div>
      )
    };
  });
};

export const mapCashflowNote = (oldNote = {}, cashFlowNotes = []) => {
  const firstNote = {
    note: <div className="text-left">{oldNote}</div>,
    timestamp: ""
  }

  const secondNotes = cashFlowNotes ? cashFlowNotes.map((item) => {
    return {
      note: <div className="text-left">{item.note}</div>,
      timestamp: moment(item.created).format("MM-DD-YYYY hh:mm A")
    }
  }) : []

  return [firstNote, ...secondNotes]
};

export const mapRoles = (value = []) => {
  return (value || []).map((item) => {
    return {
      text: item.label,
      value: item.name
    };
  });
};

export const mapRolesList = (value = [], edit, confirmDeleteRole) => {
  return value.map((item) => {
    return {
      Id: item.id,
      Role: item.storeId ? item.label : <b>{item.label}</b>,
      EditIcon: item.storeId ?
        <IconMenu
          options={[
            {
              label: LOOKUP.userRole.controls.editButton,
              onClick: () => edit(item.id)
            },
            {
              label: LOOKUP.userRole.controls.deleteButton,
              onClick: () => confirmDeleteRole(item.id)
            }
          ]}
        /> :
        <IconMenu
          options={[
            {
              label: LOOKUP.userRole.controls.editButton,
              onClick: () => edit(item.id)
            }
          ]}
        />
    };
  });
};

export const mapAccessoryCatalogList = (value = [], importToTechPOS, shopOnline) => {
  return value.map((item) => {
    return {
      logo: (
        <div>
          <img src={item.imageUrl} width="100" />
        </div>
      ),
      name: (
        <div>
          {item.name}
        </div>
      ),
      icons: (
        <div>
          <Button className="m-2" type="RaisedButton" label="Shop Online" onTouchTap={() => shopOnline(item.website)} />
        </div>
      )
    }
  })
}

export const mapSafeManagement = (value = []) => {
  return value.map((item) => {
    return {
      date: moment(item.createdDate).format('YYYY-MM-DD'),
      amount: `$ ${item.amount ? item.amount.toFixed(2) : '0.00'}`,
      notes: item.notes,
      type: item.typeDisplay,
      employee: item.employeeName,
      adjustment: item.adjustment > 0
        ? <div style={{ color: "green" }}>{item.adjustment}</div>
        : item.adjustment < 0 ? <div style={{ color: "red" }}>{item.adjustment}</div>
          : item.adjustment
    };
  });
};

export const mapEmployeeList = (value = [], edit, reset, canUpdateEmployee) => {
  return value.map((item, index) => {
    return {
      Id: (
        <Link className="edit-link"
          to={{
            pathname: `/employee/${item.id}`,
            state: { id: item.id }
          }}
        >
          {item.id}
        </Link>
      ),
      FirstName: (
        <Link to={{
          pathname: `/employee/${item.id}`,
          state: { id: item.id }
        }}>
          {item.firstName + " " + item.lastName}
        </Link>
      ),
      LastName: <Link to={{
        pathname: `/employee/${item.id}`,
        state: { id: item.id }
      }}>{item.lastName}</Link>,
      Birthdate: item.dateOfBirth ? convertDateToString(item.dateOfBirth) : "-",
      Role: item.roleLabel
        ? splitWords(item.roleLabel === "StoreOwner" ? "Executive Team" : item.roleLabel)
        : "-",
      Status:
        item.status !== "Active" ? (
          <p className="statusIconRed m-0">{item.status}</p>
        ) : (
          <p className="statusIconGreen m-0">{item.status}</p>
        ),
      EditIcon: (
        canUpdateEmployee ? 
        <IconMenu
          id={`buttonThreeDots-${index}`}
          options={[
            {
              label: LOOKUP.employee.controls.editButton,
              onClick: () => edit(item.id)
            },
            {
              label: "Reset Password",
              onClick: () => reset(item.userName ? item.userName : item.email, item.firstName + " " + item.lastName, item.role)
            }
          ]}
        /> : ""
      )
    };
  });
};

/* REPORTS */
export const mapEmployeeListReport = (value = []) => {
  return value.map((item) => {
    return {
      fullname: item.firstName + " " + item.lastName,
      Role: item.role ? splitWords(item.role) : "-"
    };
  });
};

export const mapProductList = (value = [], edit, memberEnabled, allAccess = false, isHighTide = false, isInspired = false) => {
  return value.map((item) => {
    return {
      sku: (
        <Link className="edit-link" to={`/product/${item.id}`}>
          {item.sku}
        </Link>
      ),
      name: <span><Link to={`/product/${item.id}`}>{item.name} {item.isElite && <span className="eliteProductBadge">E</span>}</Link> </span>,
      category: item.category,
      typeId: item.type,
      status:
        item.status !== "Active" ? (
          <p className="statusIconRed m-0">{item.status}</p>
        ) : (
          <p className="statusIconGreen m-0">{item.status}</p>
        ),
      // Returned price format : 'Regular Price / Promotion Price / Member Price / Elite Price'. For merged customers, only 'Regular Price / Member Price' will be shown.
      price: memberEnabled ? isHighTide ? item.price : isInspired ? item.price.split("/").slice(0, 3).join('/') : item.price.split('/').filter((_, i) => i % 2 === 0).join('/') : item.price.split("/")[0],
      icons: (
        <div>
          <Button type="IconEditButton" onTouchTap={() => edit(item.id)} disabled={!allAccess} />
        </div>
      )
    };
  });
};

export const mapInventoryAdjustList = (
  value = [],
  adjustProduct,
  confirmRound,
  priceMatrixList = [],
  form = null,
  allAccess = false,
  isVape = false
) => {
  const inventoryAdjustList = value.map((item, index) => {
    const displayName = "inventoryAdjust_displayName_" + item.productId;
    const showInDS = "inventoryAdjust_showDS_" + item.productId;
    const isDailySpecial = "inventoryAdjust_isDailySpecial_" + item.productId;
    const webMenuDisplayed = "inventoryAdjust_webMenuDisplayed_" + item.productId;
    const showPotency = "inventoryAdjust_showPotency_" + item.productId;
    const estimatedQty = "inventoryAdjust_estimatedQty_" + item.productId;
    const salePrice = "inventoryAdjust_salePrice_" + item.productId;
    const memberPrice = "inventoryAdjust_memberPrice_" + item.productId;
    const priceMatrixId = "inventoryAdjust_priceMatrixId_" + item.productId;
    const margin = "inventoryAdjust_margin_" + item.productId;
    const markup = "inventoryAdjust_markup_" + item.productId;
    const latestMargin = "inventoryAdjust_latestMargin_" + item.productId;
    const latestMarkup = "inventoryAdjust_latestMarkup_" + item.productId;
    const THCLevel = "inventoryAdjust_THCLevel_" + item.productId;
    const CBDLevel = "inventoryAdjust_CBDLevel_" + item.productId;
    const THCMax = "inventoryAdjust_thC_MAX_" + item.productId;
    const THCMin = "inventoryAdjust_thC_MIN_" + item.productId;
    const CBDMax = "inventoryAdjust_cbD_MAX_" + item.productId;
    const CBDMin = "inventoryAdjust_cbD_MIN_" + item.productId;
    const location = "inventoryAdjust_location_" + item.productId;
    const restockCap = "inventoryAdjust_restockCap_" + item.productId;
    const showSoldOut = "inventoryAdjust_showSoldOut_" + item.productId;
    const weightPerUnit = "inventoryAdjust_weightPerUnit_" + item.productId;
    const unitOfMeasurement = LOOKUP.productCategory.unitOfMeasurement.find(_ => _.value == item.unitOfMeasurement).text;
    const avgPurchasePrice = "inventoryAdjust_avgPOPrice_" + item.productId;
    const lastestPurchasePrice = "inventoryAdjust_latestPOPrice_" + item.productId;
    const profitCalculatedFromLatestPO = "inventoryAdjust_profitCalculatedFromLatestPO_" + item.productId;
    let lotNumber = "inventoryAdjust_LotNumber_" + item.productId;
    const species = ["None", "Indica", "Hybrid", "Sativa", "CBD", "Blend", "Others"];
    let warehouses = [];
    item.inventoryAdjustPackageDTO.map((x) => {
      warehouses.push({
        packageReference: x.packageReference,
        quantity: x.quantity,
        warehouseId: item.warehouseId,
        warehouseType: item.warehouseId % 3
      });
    });
    const product = {
      productCategory: item.categoryName,
      productId: item.productId,
      productName: item.productName,
      productSKU: item.sku,
      productType: item.typeId,
      warehouses: warehouses
    };
    let lotNumbers = [];
    lotNumbers.push({ text: "All", value: "0" });
    item.inventoryAdjustPackageDTO.map((x) => {
      lotNumbers.push({
        text: x.packageReference == "" ? "Empty Lot #" : x.packageReference,
        value: x.packageReference == "" ? "None" : x.packageReference
      });
    });

    let specie = species[item.species];

    return {
      ProductName: (
        <div style={{ minWidth: 120 }}>
          <img src={item.imageUrl ? item.imageUrl : imgDefault}
            className="product-image"
          />
          <br />
          {
            allAccess ?
              <Link className="inventoryAdjust-productName" to={`/product/${item.productId}`}>{item.productName}</Link>
              :
              <div className="inventoryAdjust-productName">{item.productName}</div>
          }
          <br />
          <br />
          (SKU: {item.sku})
          <br />
          <br />
          {isVape ? null : <div className="inventoryAdjust-productName">{specie}</div>}
        </div>
      ),
      ProductInfo: (
        <div>
          {isVape ? null : (
              <LotNumberSelect
                name={lotNumber}
                underlineShow={true}
                autoWidth={true}
                disabled={item.typeId != 2}
                options={lotNumbers}
                itemDetail={item}
                defaultValue="0"
                salePrice={
                  item.salePrice && item.salePrice > 0 ? item.salePrice : 0
                }
              />
          )}
            <DecimalInputInventoryAdjust
              name={weightPerUnit}
              underlineShow={true}
              hintText={"Weight(g)/Unit"}
              floatingLabelText={"Weight(gram or ml)"}
            />
            <TextInput
              name={location}
              id={`inputLocation-${0}`}
              underlineShow={true}
              label={LOOKUP.product.inventoryAdjustTable.location.label}
              hintText={"Location"}
              floatingLabelText={"Location"}
            />
        </div>
      ),
      inStock: (
        allAccess ?
          <div style={{ minWidth: 150 }}>
            <h6>Restock Cap<br />(All warehouses):</h6>
            <DecimalInputInventoryAdjustEstimatedQty
              name={restockCap}
              underlineShow={true}
              className={"inventoryAdjustInput"}
              type="number"
            />
            <span className="unitTypePostFix">
              {item.typeId == 2 ? "Unit" : "Gram"}
            </span>
            <h6>Current Stock Level ({form && form.inventoryAdjustWarehouseText ? form.inventoryAdjustWarehouseText : `Store`}):</h6>
            <DecimalInputInventoryAdjustEstimatedQty
              name={estimatedQty}
              className={"inventoryAdjustInput"}
              underlineShow={true}
              label={LOOKUP.product.inventoryAdjustTable.estimatedQty.label}
              disabled={true}
            />
            <span className="unitTypePostFix">
              {item.typeId == 2 ? "Unit" : "Gram"}
            </span>
            <Button
              label="Adjust"
              id={`buttonOpenInventoryAdjust-${index}`}
              onTouchTap={() => adjustProduct(product)}
              className={"inventory-estimated-Qty mt-12px"}
              type="RaisedButton"
            />
          </div>
          : "N.A."
      ),
      SalePrice:
        item.typeId == 2 ? (
          <div style={{ minWidth: 150 }}>
            <h6>Regular Price:</h6>
            <span className="dollarSign">$</span>
            <DecimalInputInventoryAdjust
              name={salePrice}
              className={"inventoryAdjustInput"}
              underlineShow={true}
              label={LOOKUP.product.inventoryAdjustTable.salePrice.label}
              min={0}
              poPrice={
                form[avgPurchasePrice] > 0 && item.typeId == 2
                  ? form[avgPurchasePrice]
                  : 0
              }
              latestPOPrice={
                form[lastestPurchasePrice] > 0 && item.typeId == 2
                  ? form[lastestPurchasePrice]
                  : 0
              }
              disabled={!allAccess}
            />
            <span className="unitTypePostFix">/ Unit</span>
            <h6>Member Price:</h6>
            <span className="dollarSign">$</span>
            <DecimalInputInventoryAdjust
              name={memberPrice}
              className={"inventoryAdjustInput"}
              underlineShow={true}
              label={LOOKUP.product.inventoryAdjustTable.salePrice.label}
              min={0}
              disabled={!allAccess}
            />
            <span className="unitTypePostFix">/ Unit</span>
            <Button
              onTouchTap={() => confirmRound(product)}
              className={"inventory-estimated-Qty btnNewBrandPOS mt-12px"}
              label={"ROUND"}
              id={`buttonRoundPrices-${index}`}
              type="SaveButtonNoIcon"
            />
          </div>
        ) : (item.typeId == 1 || item.typeId == 3) &&
          priceMatrixList.length > 0 ? (
          <SelectInput
            name={priceMatrixId}
            underlineShow={true}
            className="inventoryAdjust-selectInput"
            style={{ width: "100%", position: "relative", left: "20px" }}
            options={priceMatrixList}
          />
        ) : null,
      AvgPurchasePrice:
        <div className="d-flex justify-content-center flex-wrap" style={{ minWidth: 150 }}>
          <h6>Lastest Purchase Order Price:</h6>
          {
            form[lastestPurchasePrice] > 0 && allAccess ? (
              <div>
                <span className="dollarSign">$</span>
                <DecimalInputInventoryAdjust
                  name={lastestPurchasePrice}
                  className={"inventoryAdjustInput"}
                  underlineShow={true}
                  label={LOOKUP.product.inventoryAdjustTable.avgPOPrice.label}
                  disabled={true}
                />
                <span className="unitTypePostFix">
                  {item.typeId == 2 ? "/Unit" : "/g"}
                </span>
              </div>
            ) : (
              "N.A."
            )
          }
          <h6>Average Purchase Order Price:</h6>
          {
            form[avgPurchasePrice] > 0 && allAccess ? (
              <div>
                <span className="dollarSign">$</span>
                <DecimalInputInventoryAdjust
                  name={avgPurchasePrice}
                  className={"inventoryAdjustInput"}
                  underlineShow={true}
                  label={LOOKUP.product.inventoryAdjustTable.avgPOPrice.label}
                  disabled={true}
                />
                <span className="unitTypePostFix">
                  {item.typeId == 2 ? "/Unit" : "/g"}
                </span>
              </div>
            ) : (
              "N.A."
            )
          }
        </div>
      ,
      Profit:
        (
          <div style={{ minWidth: 200 }}>
            {
              form[avgPurchasePrice] > 0 && item.typeId == 2 && allAccess && !form[profitCalculatedFromLatestPO] ? (
                <div>
                  <DecimalInputInventoryAdjust
                    name={margin}
                    className={"inventoryAdjustMarginInput"}
                    underlineShow={true}
                    hintText={LOOKUP.product.inventoryAdjustTable.margin.label}
                    floatingLabelText={
                      LOOKUP.product.inventoryAdjustTable.margin.label
                    }
                    min={0}
                    poPrice={
                      form[avgPurchasePrice] > 0 && item.typeId == 2
                        ? form[avgPurchasePrice]
                        : 0
                    }
                    latestPOPrice={
                      form[lastestPurchasePrice] > 0 && item.typeId == 2
                        ? form[lastestPurchasePrice]
                        : 0
                    }
                  />
                  <span className="marginPostFix">%</span>
                  <DecimalInputInventoryAdjust
                    name={markup}
                    className={"inventoryAdjustMarginInput"}
                    underlineShow={true}
                    hintText={"markup"}
                    floatingLabelText={"markup"}
                    min={0}
                    poPrice={
                      form[avgPurchasePrice] > 0 && item.typeId == 2
                        ? form[avgPurchasePrice]
                        : 0
                    }
                    latestPOPrice={
                      form[lastestPurchasePrice] > 0 && item.typeId == 2
                        ? form[lastestPurchasePrice]
                        : 0
                    }
                  />
                  <span className="marginPostFix">%</span>
                </div>
              )
                :
                form[lastestPurchasePrice] > 0 && item.typeId == 2 && allAccess && form[profitCalculatedFromLatestPO] ? (
                  <div>
                    <DecimalInputInventoryAdjust
                      name={latestMargin}
                      className={"inventoryAdjustMarginInput"}
                      underlineShow={true}
                      hintText={LOOKUP.product.inventoryAdjustTable.margin.label}
                      floatingLabelText={
                        LOOKUP.product.inventoryAdjustTable.margin.label
                      }
                      min={0}
                      poPrice={
                        form[avgPurchasePrice] > 0 && item.typeId == 2
                          ? form[avgPurchasePrice]
                          : 0
                      }
                      latestPOPrice={
                        form[lastestPurchasePrice] > 0 && item.typeId == 2
                          ? form[lastestPurchasePrice]
                          : 0
                      }
                    />
                    <span className="marginPostFix">%</span>
                    <DecimalInputInventoryAdjust
                      name={latestMarkup}
                      className={"inventoryAdjustMarginInput"}
                      underlineShow={true}
                      hintText={"markup"}
                      floatingLabelText={"markup"}
                      min={0}
                      poPrice={
                        form[avgPurchasePrice] > 0 && item.typeId == 2
                          ? form[avgPurchasePrice]
                          : 0
                      }
                      latestPOPrice={
                        form[lastestPurchasePrice] > 0 && item.typeId == 2
                          ? form[lastestPurchasePrice]
                          : 0
                      }
                    />
                    <span className="marginPostFix">%</span>
                  </div>
                )
                  : (<div>N.A.<br /></div>)
            }
            <h6>Calculate from: </h6>
            <ToggleInput name={profitCalculatedFromLatestPO} className="calculate-from-toggle"  option1={"Average PO"} option2={"Latest PO"} lineBreak />
          </div>
        ),
      Potency: (
        form[`${lotNumber}`] == "0" ? (
          <div style={{ minWidth: 80 }}>
            <div className="d-flex">
              <DecimalInput
                name={THCMax}
                label="THC MAX"
                containerName={"inventoryAdjustPotencyInput"}
                floatingLabelText={`THC MAX(${unitOfMeasurement})`}
                hintText={`THC MAX`} />
            </div>
            <div className="d-flex">
              <DecimalInput
                name={THCMin}
                label="THC MIN"
                containerName={"inventoryAdjustPotencyInput"}
                floatingLabelText={`THC MIN(${unitOfMeasurement})`}
                hintText="THC MIN" />
            </div>
            <div className="d-flex">
              <DecimalInput
                name={CBDMax}
                type="number"
                containerName={"inventoryAdjustPotencyInput"}
                label="CBD MAX"
                floatingLabelText={`CBD MAX(${unitOfMeasurement})`}
                hintText="CBD MAX" />
            </div>
            <div className="d-flex">
              <DecimalInput
                name={CBDMin}
                type="number"
                containerName={"inventoryAdjustPotencyInput"}
                label="CBD MIN"
                floatingLabelText={`CBD MIN(${unitOfMeasurement})`}
                hintText="CBD MIN" />
            </div>
          </div>
        ) :
          (
            <div className="br">
              <div>
                <DecimalInputInventoryAdjust
                  name={THCLevel}
                  className={"inventoryAdjustMarginInput"}
                  underlineShow={true}
                  hintText={"THC"}
                  floatingLabelText={"THC"}
                  min={0}
                />
                <span className="marginPostFix">{LOOKUP.productCategory.unitOfMeasurement.find(_ => _.value == item.unitOfMeasurement).text}</span>
              </div>
              <div>
                <DecimalInputInventoryAdjust
                  name={CBDLevel}
                  className={"inventoryAdjustMarginInput"}
                  underlineShow={true}
                  hintText={"CBD"}
                  floatingLabelText={"CBD"}
                  min={0}
                />
                <span className="marginPostFix">{LOOKUP.productCategory.unitOfMeasurement.find(_ => _.value == item.unitOfMeasurement).text}</span>
              </div>
              <h6>Show Potency:</h6> <ToggleInput name={showPotency} className="daily-special-toggle"  option2={'True'} option1={'False'}/>
            </div>
          )
      ),
      DisplayName: (
        <div>
          <TextInput
            name={displayName}
            fullWidth={true}
            underlineShow={true}
            hintText={"Display Name"}
            floatingLabelText={"Display Name"}
          />
          <h6>Show in digital signage:</h6>
          <ToggleInput name={showInDS} className="ph-toggle-enable-disable"  option2={'Enable'} option1={'Disable'}/>
          <h6>Daily special:</h6>
          <ToggleInput name={isDailySpecial} className="ph-toggle-false-true"   option2={'True'} option1={'False'}/>
        </div>
      ),
      Ecommerce: (
        <div>
          <h6>Show in web menu:</h6>
          <ToggleInput name={webMenuDisplayed} className="ph-toggle-enable-disable" option2={'Enable'} option1={'Disable'}/>
          <h6>Show after Sold Out:</h6>
          <ToggleInput name={showSoldOut} className="ph-toggle-false-true" option2={'True'} option1={'False'}/>
        </div>
      )
    };

  });

  if (isVape) {
    delete inventoryAdjustList.Potency;
  }

  return inventoryAdjustList;
}

export const mapAuditList = (value = [], isOwner, toggleOpenDialog, getSelectedId, downloadCsv) => {
  return value.map((item, index) => {
    return {
      id: item.id,
      name: item.name,
      date: moment(item.modifiedDate).format('MM-DD-YYYY'),
      productCount: item.totalCount,
      status: item.status == 1 ? "Pending" : item.status == 2 ? "Completed" : item.status == 3 ? "Verify" : item.status == 4 ? "Recount" : "",
      edit: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

          <UseNavigateAssistant
            component={<Button className="audit-list-button" type="EditButton" id={`buttonEditAudit-${index}`} label={item.status == 1 ? "EDIT" :
              item.status == 3 ? (isOwner ? "VERIFY" : "EDIT") : item.status == 4 ? (isOwner ? "EDIT" : "RECOUNT") : "VIEW"} />}
            route={`/inventoryaudit/${item.id}`} />
          <section>
            {<Button type="IconButton" mini={true} iconStyle={{ color: "red" }} id={`buttonDeleteAudit-${index}`}
              className="fas fa-times-circle danger" onTouchTap={() => { toggleOpenDialog(); getSelectedId(item.id); }} />}
          </section>
          {<Button type="IconButton" mini={true} id={`buttonDownloadAuditCSV-${index}`}
            className="fas fa-cloud-download-alt"
            onTouchTap={() => downloadCsv(item.id)}
          />}
        </div>
      )
    };
  });
};

export const mapInventoryAudit = (form, value = [], deleteProduct, isComplete, verifyProduct, updateAuditProductQuantity, updateAuditProductNotes, auditUpdating, lockExpectedQuantity, handleFocus, handleBlur) => {

  return value.map((item, i) => {
    const formQty = form && form[`InventoryAudit_${item.id}_${item.warehouseType}_Quantity`];
    const expectedQty = lockExpectedQuantity && item.expectedQty != null ? item.expectedQty : item.inStock;
    const isDiff = form && formQty != null && !isNaN(formQty) && (formQty != expectedQty);
    const diff = isDiff && (formQty - expectedQty);
    const diffCost = isDiff && diff * item.wac;
    const color = isDiff ? (diff > 0 ? 'green' : 'red') : 'black'
    return {
      id: item.id,
      selectable: isDiff && !isComplete,
      name: (
        <Link to={`/product/${item.id}`} style={{ fontSize: '16px', fontWeight: 600 }}>
          <span>{item.name}</span>
        </Link>
      ),
      sku: (
        <Link to={`/product/${item.id}`} style={{ fontSize: '14px' }}>
          <span>{item.sku}</span>
        </Link>
      ),
      location: (
        <h6>{item.location}</h6>
      ),
      warehouseType: (
        <h6>{item.warehouseTypeName}</h6>
      ),
      newquantity: (
        <TextInputOnBlurCallApi name={`InventoryAudit_${item.id}_${item.warehouseType}_Quantity`}
          hintText={"Quantity"}
          className="table-field"
          type="number"
          fullWidth={true}
          label="Quantity"
          disabled={isComplete || auditUpdating}
          onBlur={(e) => updateAuditProductQuantity(e, item.id, item.warehouseType, form[`InventoryAudit_${item.id}_${item.warehouseType}_Quantity`])} />
      ),
      expectedQty: (
        <span>{expectedQty} &nbsp;&nbsp;
          {isDiff && <Button label="adjust" onTouchTap={() => verifyProduct(item)} />}
        </span>
      ),
      diff,
      diffCost,
      differenceQty: <span style={{ color }}>{isDiff ? diff.toFixed(2) : ''}</span>,
      differenceCost: <span style={{ color }}>{isDiff ? diffCost.toFixed(2) : ''}</span>,
      notes: (
        <TextInputOnBlurCallApi name={`InventoryAudit_${item.id}_${item.warehouseType}_Notes`}
          hintText={"Notes"}
          className="table-field"
          type="text"
          fullWidth={true}
          label="Notes"
          onBlur={(e) => updateAuditProductNotes(e, item.id, item.warehouseType, form[`InventoryAudit_${item.id}_${item.warehouseType}_Notes`])}
          disabled={auditUpdating} />
      ),
      delete: (
        !isComplete && <div>
          <Button type="IconDeleteButton" className="IconDeleteButton" onTouchTap={() => deleteProduct(item)} />
        </div>
      )
    };
  });
};

export const mapAuditAdjust = (warehouses = [], productid, pendingBulkTransferProducts) => {
  return warehouses.map((item) => {
    let pendingBulkTransferProduct = pendingBulkTransferProducts.filter(x => x.packageReference == item.packageReference && x.warehouseId == item.warehouseId)
    return {
      warehouseId:
        item.warehouseId % 3 === 1
          ? "Storage"
          : item.warehouseId % 3 === 2
            ? "Store (Sell)"
            : "Damage",
      packageReference:
        item.packageReference !== null &&
          item.packageReference !== undefined &&
          item.packageReference !== ""
          ? item.packageReference
          : "No lot number",
      quantity: item.quantity,
      pendingTransfer: pendingBulkTransferProduct.length > 0 ? pendingBulkTransferProduct[0].quantityTransfered : 0,
      newquantity: (
        <TextInput name={`InventoryAuditAdjust_${productid}_${item.warehouseId}_${item.packageReference}`}
          hintText={"Quantity"}
          className="table-field"
          type="number"
          fullWidth={true}
          label="Quantity" />)
    };
  });
};

export const mapWarehouseListTransfer = (value = [], pendingBulkTransferProducts) => {
  return value.map((item) => {
    let pendingBulkTransferProduct = pendingBulkTransferProducts != null ? pendingBulkTransferProducts.filter(x => x.packageReference == item.packageReference && x.warehouseId == item.warehouseId) : []
    return {
      warehouseType:
        item.warehouseType === 1
          ? "Storage"
          : item.warehouseType === 2
            ? "Store (Sell)"
            : "Damage",
      packageReference:
        item.packageReference !== null &&
          item.packageReference !== undefined &&
          item.packageReference !== ""
          ? item.packageReference
          : "No lot number",
      quantity: item.quantity,
      pendingTransfer: pendingBulkTransferProduct.length > 0 ? pendingBulkTransferProduct[0].quantityTransfered : 0
    };
  });
};

export const mapPriceMatrix = (pricematrix = [], printLabel, productId) => {
  return pricematrix
    .filter((item) => item.price !== 0 || item.memberPrice !== 0)
    .map((item) => {
      return {
        WeightSetting: item.weightName,
        Price: getDollarFormat(item.price),
        MemberPrice: getDollarFormat(item.memberPrice),
        Icon: (
          <Button
            className="printBtn"
            type="PrintButton"
            label=""
            //We need to keep the old standard - Added the quantity(weight) on the label
            onTouchTap={() =>
              printLabel(
                `${String(productId).padStart(5, "0")}${String(
                  item.weight
                ).padStart(6, "0")}`.slice(-11),
                item.weight,
                getDollarFormat(item.price)
              )
            }
          />
        )
      };
    })
    .sort((a, b) => {
      if (a.Price < b.Price) return -1;
      if (a.Price > b.Price) return 1;
      return 0;
    });
};

export const mapMatrices = (value = []) => {
  return value.map((item) => {
    return {
      text: item.name,
      value: item.id
    };
  });
};

export const mapTypes = (value = []) => {
  return value.map((item) => {
    return {
      text: item.name,
      value: item.id
    };
  });
};

export const mapClassOfCannabis = (value = []) => {
  const classes = value.map((item) => {
    return {
      text: item.name,
      value: item.id
    };
  });
  return classes;
};

export const getOrderStatusIcon = (id) => {
  const completed = (
    <span className="fas fa-check  green-text">
      <p className="transferIcons">Completed</p>
    </span>
  );
  const opened = (
    <span className="fas fa-external-link-alt orange-text">
      <p className="transferIcons">Opened</p>
    </span>
  );
  const cancelled = (
    <span className="fas fa-times danger">
      <p className="transferIcons">Cancelled</p>
    </span>
  );
  const returned = (
    <span className="fas fa-sync-alt danger">
      <p className="transferIcons">Returned</p>
    </span>
  );
  const returnedPartial = (
    <span className="fas fa-sync-alt danger">
      <p className="transferIcons">Returned Partial</p>
    </span>
  );

  switch (id) {
    case "Opened":
      return opened;
    case "Completed":
      return completed;
    case "Cancelled":
      return cancelled;
    case "Returned":
      return returned;
    case "Returned Partial":
      return returnedPartial;
    default:
      return opened;
  }
};

/* EMPLOYEE STATUS FUNCTION WITH ICONS */
export const getStatusIcon = (id) => {
  const approved = (
    <span className="fas fa-check green-text">
      <p className="transferIcons">Approved</p>
    </span>
  );
  const pending = (
    <span className="fas fa-times orange-text">
      <p className="transferIcons">Pending</p>
    </span>
  );
  const disapproved = (
    <span className="fas fa-times danger">
      <p className="transferIcons">Disapproved</p>
    </span>
  );

  switch (id) {
    case "Approved":
      return approved;

    case "Pending":
      return pending;

    case "Disapproved":
      return disapproved;

    default:
      return pending;
  }
};

//HELP FUNCTION

function getWarehouseName(id) {
  const storageIcon = <span className="fas fa-th-list blue-text"><p className="transferIcons">Storage</p></span>;
  const storeIcon = <span className="fas fa-store green-text"><p className="transferIcons">Store</p></span>;
  const damageIcon = <span className="fas fa-exclamation-circle danger"><p className="transferIcons">Damage</p></span>;
  id = parseInt(id, 10);
  if (id % 3 === 1) {
    return storageIcon;
  } else if (id % 3 === 2) {
    return storeIcon;
  } else {
    return damageIcon;
  }
}

export const mapWarehouse = (value = [], amounts, toWarehouse, warehouses = [], adjustProduct, convertToJoint, validateTableComponents, transferSingleProduct) => {
  return value.map((item, index) => {
    const quantity = (item.isUnitProduct) ? parseFloat(item.quantity).toFixed(0) : parseFloat(item.quantity).toFixed(1);
    const warehousesOptions = mapWarehouseFilter(warehouses.filter(w => w.id !== item.warehouseId));

    return {
      SKU: (<Link className="edit-link" to={`/product/${item.productId}`}>{item.productSKU}</Link>),
      Name: (<Link className="edit-link" to={`/product/${item.productId}`}>{item.productName}</Link>),
      TypeCategory: `[${item.productType}] ${item.productCategory}`,
      Quantity: `${item.isUnitProduct ? quantity + ' unit(s)' : quantity + ' g'}`,
      Warehouse: getWarehouseName(item.warehouseId),
      Amount: (item.isUnitProduct)
        ?
        <TextInput name={`SingleTransfer${item.productId}-${item.warehouseId}Amount`}
          underlineShow={false}
          hintText={LOOKUP.transferProduct.amount.hintText}
          className="table-field"
          ref={(input) => amounts[index] = input}
          type="number" fullWidth={true}
          label="Amount"
          min={0}
          onInput={(e) => validateTableComponents(e, item)}
          max={quantity} />
        :
        <WeightInput name={`SingleTransfer${item.productId}-${item.warehouseId}Amount`}
          underlineShow={false}
          hintText={LOOKUP.transferProduct.amount.hintText}
          className="table-field"
          ref={(input) => amounts[index] = input}
          type="number" fullWidth={true}
          label="Amount"
          min={0}
          max={quantity} />,
      ToWarehouse: <SelectInput name={`SingleTransfer${item.productId}-${item.warehouseId}ToWarehouse`}
        underlineShow={false}
        className="table-field"
        ref={(input) => toWarehouse[index] = input}
        label={LOOKUP.transferProduct.warehouse.label}
        hintText={LOOKUP.transferProduct.warehouse.hintText}
        style={{ width: '100%' }}
        options={warehousesOptions} />,
      TransferIcon: <Button name={`SingleTransfer${item.productId}-${item.warehouseId}Transfer`}
        type="IconButton" className="glyphicon glyphicon-transfer"
        onTouchTap={() => transferSingleProduct(item, index)} />,
      Adjust: (<Button name={`${item.productId}-${item.warehouseId}Adjust`}
        type="IconButton" className="glyphicon glyphicon-tasks"
        onTouchTap={() => adjustProduct(item, index)} />),
      Joint: (item.productMeasurementType && item.productMeasurementType === MeasurementType.Gram && (item.warehouseId % 3 === 1)) ? (
        <Button name={`${item.productId}-${item.warehouseId}Joint`}
          type="IconButton" className="glyphicon glyphicon-import"
          onTouchTap={() => convertToJoint(item)} />
      ) : ''
    }
  });
};

export const mapWarehouseCard = (value = [], adjustProduct, convertToJoint, transferProduct, bulkToUnitProduct, isMedical, clearOnHoldQty, canViewTransferAdjust) => {

  return value.map((item, index) => {

    return {
      ProductInfo: (
        <div className="row m-0 pb-2 pt-2">
          <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
            <Link className="edit-link" to={`/product/${item.productId}`}>
              <div className="row" >
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left">
                  <h3><b>{item.productName}</b></h3>

                  <p className="m-0 font-weight-normal">SKU: {item.productSKU}</p>
                  <p className="m-0 font-weight-normal">{`${item.productType} - ${item.productCategory}`} </p>

                  {
                    <p className="m-0 font-weight-normal lots-margin d-flex">
                      {item.packages.map((pk, indexpk) => <div className="lot-number-label" key={indexpk}>{!pk ? 'No lot number' :  `#${pk}`}</div>)}
                    </p>
                  }
                </div>
                {
                  item.totals.map((total, indexw) => {
                    return (
                      <div id={`warehouseQuantities-${index}-${indexw}`} className="col-lg-2 col-md-2 col-sm-2 col-xs-4 text-center quantity-warehouse-product" key={indexw}>
                        <h3>{total.quantity} <h5>{total.onHoldQty > 0 ? `(${total.onHoldQty} On Hold)` : ''}</h5></h3>
                        <p className="text-center">
                          {`${item.isUnitProduct ? 'unit(s)' : 'gram(s)'}`}<br />
                          {getWarehouseName(total.warehouseType)}
                        </p>
                      </div>
                    );
                  })
                }
              </div>
            </Link>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            {canViewTransferAdjust &&
              <div>
                <Button name={`SingleTransfer${item.productId}-${item.warehouseId}Transfer`}
                  type="IconTransferButton"
                  id={`buttonTransfer-${index}`}
                  className="mb-3 trans_btns btnNewBrandPOS"
                  onTouchTap={() => transferProduct(item, index)} />
                <Button name={`${item.productId}-${item.warehouseId}Adjust`}
                  type="IconSettingsButton"
                  id={`buttonAdjust-${index}`}
                  className="mb-3 trans_btns bg-light-green"
                  onTouchTap={() => adjustProduct(item, index)} />
              </div>
            }
            {
              (item.totals).find(a => a.onHoldQty > 0) && (
                <Button name={`${item.productId}-${item.warehouseId}Clear`}
                  id={`buttonClearHold-${index}`}
                  type="IconClearButton"
                  label={"CLEAR HOLD"}
                  className="mb-3 trans_btns"
                  onTouchTap={() => clearOnHoldQty(item)} />
              )
            }

            {(item.productMeasurementType && item.productMeasurementType === MeasurementType.Gram && (item.totals[0].quantity > 0) && isMedical) ? (
              <Button name={`${item.productId}-${item.warehouseId}Joint`}
                type="IconJointButton"
                className="mb-3 trans_btns"
                onTouchTap={() => convertToJoint(item)} />
            ) : ''}

            {(item.productMeasurementType && item.productMeasurementType === MeasurementType.Gram && (item.totals[0].quantity > 0) && isMedical) ? (
              <Button name={`${item.productId}-${item.warehouseId}BulkToJoint`}
                type="BulkToUnitButton"
                className="mb-3 trans_btns"
                onTouchTap={() => bulkToUnitProduct(item)} />
            ) : ''}
          </div>
        </div>
      )
    }
  });
};

export const mapWarehouseFilter = (value = []) => {
  return value.map((item) => {
    return {
      text: item.name,
      value: item.id
    };
  });
};

export const mapTransferWarehouseFrom = (value = [], addToTrasnfer) => {
  return value.map((item) => {
    const quantity = item.isUnitProduct
      ? parseFloat(item.quantity).toFixed(0)
      : parseFloat(item.quantity).toFixed(1);
    const formName = `TransferTo${item.productId}Amount`;
    return {
      SKU: item.productSKU,
      Name: item.productName,
      Quantity: `${item.isUnitProduct ? quantity + " unit(s)" : quantity + " g"
        }`,
      TransferIcon: (
        <SwapHorizIcon className="pointer" onClick={() => addToTrasnfer(item, formName)} />
      )
    };
  });
};

export const mapTransferWarehouseTo = (
  value = [],
  validateTableComponents,
  removeFromTransfer
) => {
  return value.map((item) => {
    const quantity = item.isUnitProduct
      ? parseFloat(item.quantity).toFixed(0)
      : parseFloat(item.quantity).toFixed(1);
    const formName = `TransferTo${item.productId}Amount`;
    return {
      SKU: item.productSKU,
      Name: item.productName,
      Amount: item.isUnitProduct ? (
        <TextInput
          name={formName}
          underlineShow={false}
          hintText={"Amount"}
          className="table-field"
          type="number"
          fullWidth={true}
          label="Amount"
          min={0}
          onInput={(e) => validateTableComponents(e, item)}
          max={quantity}
        />
      ) : (
        <WeightInput
          name={formName}
          underlineShow={false}
          hintText={"Amount"}
          className="table-field"
          type="number"
          fullWidth={true}
          label="Amount"
          min={0}
          max={quantity}
        />
      ),
      CancelIcon: (
        <CancelIcon
          className="pointer"
          onClick={() => removeFromTransfer(item, formName)}
        />
      )
    };
  });
};

export const mapToCalendar = (schedules = []) => {
  return schedules.map((item) => {
    return {
      id: item.id,
      start: new Date(item.startShift),
      end: new Date(item.endShift),
      title: item.employeeName,
      className: "testing-css",
      color: item.color,
      recursiveId: item.recursiveId
    };
  });
};

export const mapOfflineOrder = (order) => {
  return {
    id: order && order.id ? order.id : 0,
    status: "Opened",
    classesOfCannabis: [],
    limitEquivalentInGramsOfDriedCannabis: "30.00",
    patientId: order && order.patientId ? order.patientId : null,
    patientFirstName: order && order.patientFirstName ? order.patientFirstName : null,
    patientLastName: order && order.patientLastName ? order.patientLastName : null,
    patientVisitCount: order && order.patientVisitCount ? order.patientVisitCount : 0,
    payments: [],
    hasDiscounts: order && order.hasDiscounts,
    discounts: [],
    refund: 0.0,
    hasRefunds: false,
    shippingRefunded: false,
    refundDate: null
  }
}

export const mapOfflineProducts = (oldProducts, newProducts, order) => {
  const updatedProducts = [];
  const patientId = order ? order.patientId : null;
  let isQtyInStock = true;
  
  (newProducts || []).forEach((newProduct) => {
      const price = getProductPrice(newProduct, patientId);
      const quantityInStock = newProduct.quantityInStock;
      const quantityInCart = [...updatedProducts, ...oldProducts]
                              .filter(product => product.productId == newProduct.productId)
                              .reduce((total, product) => total + (product.quantity || 0), 0)
                              + (newProduct.newQuantity || 1);

      if (quantityInCart > quantityInStock) {
          isQtyInStock = false;
          return;
      }
     
      const packageReference = newProduct.packageReference ? newProduct.packageReference : null
    
      updatedProducts.push({
        id: 0,
        orderId: 0,
        orderProductId: newProduct.orderProductId || oldProducts.length + updatedProducts.length + 1,
        productId: newProduct.id == 0 ? newProduct.productId : newProduct.id,
        name: newProduct.name,
        category: newProduct.category,
        sku: newProduct.sku,
        quantity: newProduct.newQuantity || 1,
        quantityInStock: quantityInStock,
        packages: newProduct.packages,
        packageReference: packageReference,
        imageUrl: newProduct.imagesUrls && newProduct.imagesUrls[0],
        status: newProduct.status ? newProduct.status : 1,
        dfe: newProduct.dfe,
        isCannabis: newProduct.isCannabis,
        weightPerUnit: newProduct.weightPerUnit,
        measurementType: newProduct.measurementType,
        isInCombo: newProduct.comboProducts ? newProduct.comboProducts.length > 0 : false,
        unitPrice: newProduct.unitPrice,
        promotionUnitPrice: newProduct.promotionUnitPrice,
        memberUnitPrice: newProduct.memberUnitPrice,
        originalNonMemberPrice: newProduct.unitPrice ? (newProduct.unitPrice + (newProduct.depositAmount || 0)) * (newProduct.newQuantity || 1) : 999,
        price: (newProduct.unitPrice + (newProduct.depositAmount || 0)) * (newProduct.newQuantity || 1),
        depositAmount: newProduct.depositAmount || 0,
        productDiscountList: [],
        discountType: newProduct.unitPrice * (newProduct.newQuantity || 1) > price.price && OrderDiscountType.Amount,
        discountAmount: (newProduct.unitPrice - price.price) * (newProduct.newQuantity || 1),
        discountValue: (newProduct.unitPrice - price.price) * (newProduct.newQuantity || 1),
        notes: price.notes // Only for Inspired
      });
    }
  );
 
  return isQtyInStock ? [...updatedProducts, ...oldProducts] : null;
}

const getProductPrice = (product, patientId = null) => {
  if (patientId && product.memberUnitPrice && product.memberUnitPrice != 999) {
    return { price: product.memberUnitPrice, notes: "Member price discount" };
  }

  if (product.promotionUnitPrice && product.promotionUnitPrice != 999) {
    return { price: product.promotionUnitPrice, notes: "Promotion price discount" };
  }

  if (product.price) {
    return { price: product.price }
  }

  return { price: product.unitPrice }
}
